import { render, staticRenderFns } from "./EventManagement.vue?vue&type=template&id=7c0e4fe8&"
import script from "./EventManagement.vue?vue&type=script&lang=js&"
export * from "./EventManagement.vue?vue&type=script&lang=js&"
import style0 from "./EventManagement.vue?vue&type=style&index=0&id=7c0e4fe8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QTabs,QTab,QTabPanels,QTabPanel,QBtn,QTable,QTd,QDialog,QCard,QCardSection,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QTabs,QTab,QTabPanels,QTabPanel,QBtn,QTable,QTd,QDialog,QCard,QCardSection,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
